import { ServerFilterClauses } from '~commonInfra/utils/ServerFilterClauses';
import { Messages } from '~src/codegen/Localize';
import { RunFlowTasks } from '~src/flow/resources/RunFlowTasks';
import { ContentTypeFilterClause, ExplorableItemDefinition } from '~src/spacesPlatform/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { RunFlowTaskContentType } from '~src/spacesPlatform/models/ContentTypes';

import { getGenericDefaultFilters } from '../../spacesPlatform/contentDefinitions/getDefaultFilters';

export const RunFlowTaskDefinition: ExplorableItemDefinition = {
  itemType: 'runFlowTask',
  pluralName: Messages.flows,
  singularName: Messages.flow,
  emptyStateMessage: Messages.flowsEmptyMessage,
  contentFilterKeys: RunFlowTaskContentType.filterKeys,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: null,
  listViewIconUrl: '', // we don't display an icon for run flow tasks runs
  filterClause: ServerFilterClauses.ContentType(['runFlowTask']) as ContentTypeFilterClause,
  getBasicQuery: () => {
    return RunFlowTasks.all().withExtraParams(RunFlowTaskContentType.extraQueryParams);
  },
  getContentInfo: () => {
    throw new Error('getContentInfo is not implemented for runFlowTask');
  },
  supportedDisplayModes: ['list']
};
